var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"banner"}),_c('div',{staticClass:"marquee-wrapper"},[_c('marquee',{staticClass:"info",attrs:{"direction":"left"}},[_c('span',[_vm._v("最新公告： 尊敬的用户，百万富翁资讯网拥有世界各地的彩票！")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }